// Utility functions for creating filter strings in the format expected by the backend

export interface FilterCondition {
  field: string;
  op: 'eq' | 'ne' | 'gt' | 'ge' | 'lt' | 'le' | 'in' | 'nin' | 'contains' | 'icontains' | 'startswith' | 'endswith' | 'isnull' | 'like' | 'ilike';
  value: any;
}

/**
 * Creates a filter string for a single field
 * @param field - The field name to filter on
 * @param value - The value to filter by
 * @param op - The operator to use (default: 'eq')
 * @returns JSON string of filter array
 */
export const createFilter = (field: string, value: any, op: FilterCondition['op'] = 'eq'): string => {
  return JSON.stringify([{ field, op, value }]);
};

/**
 * Creates a filter string from multiple conditions
 * @param conditions - Array of filter conditions
 * @returns JSON string of filter array
 */
export const createFilters = (conditions: FilterCondition[]): string => {
  return JSON.stringify(conditions);
};

/**
 * Creates an organization filter
 * @param organizationId - The organization ID to filter by
 * @returns JSON string of filter array
 */
export const createOrganizationFilter = (organizationId: number): string => {
  return createFilter('organization_id', organizationId);
};